// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SlideoutLayout from '../../../layout/slideout/SlideoutLayout';

import {
  savePackageType,
  getPackageTypeById,
} from '../../../../actions/packageTypeActions';
import { toast } from 'react-toastify';
import PackageTypeForm from '../components/PackageTypeForm';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/Button';

function EditPackageType({
  done,
  id,
  cancel,
  savePackageType,
  getPackageTypeById,
}) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();

  const [packageType, setPackageType] = useState({ keyProviderReferences: {} });

  useEffect(() => {
    if (id) {
      getPackageTypeById(id).then((d) => {
        setPackageType(d);
      });
    }
  }, [id, getPackageTypeById]);

  const onSubmit = (data) => {
    if (!packageType) {
      toast.error(t('Failed to save package type'));
      return;
    }

    savePackageType({
      ...packageType,
      ...data,
    }).then(() => {
      toast.success(t('Package type saved'));
      done(packageType);
    });
  };

  return (
    <SlideoutLayout
      title={id ? t('Edit package type') : t('Add package type')}
      cancel={cancel}
      done={done}
      bar={
        <Button
          key="save"
          text={t('Save')}
          className="btn btn-primary"
          onClick={handleSubmit(onSubmit)}
          testId="save-package-type-button"
        />
      }
    >
      <PackageTypeForm
        packageType={packageType}
        register={register}
        errors={errors}
        control={control}
        setPackageType={setPackageType}
      />
    </SlideoutLayout>
  );
}




const mapDispatchToProps = {
  savePackageType,
  getPackageTypeById,
};

export default connect(null, mapDispatchToProps)(EditPackageType);
